"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports["default"] = (function (size, color) { return (react_1["default"].createElement("svg", { version: "1.1", id: "Layer_1", x: "0px", y: "0px", width: size, height: size, viewBox: "0 0 4 6", xmlSpace: "preserve" },
    react_1["default"].createElement("path", { fill: color, id: "arrow--winner", d: "M0,3l4-3v6L0,3z" }))); });
